<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/rewardlist/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="类型">
        <el-select v-model="formModel.awardType">
          <el-option
            v-for="item in awardType"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="奖励期数">
        <el-select v-model="formModel.cycle">
          <el-option
            v-for="item in Week"
            :key="item.weekIndex"
            :label="item.week + ' ' + item.date"
            :value="item.weekIndex"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="发放时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="awardType"
        label="类型"
        :formatter="formatterTableawardType"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.status == 0
              ? "已拒绝"
              : scope.row.status == 1
              ? "待审核"
              : scope.row.status == 2
              ? "已发放"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="awardAmt"
        label="金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="发放时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cycle"
        label="奖励期数"
        :formatter="formatterTablecycle"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="日期" min-width="260" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.startTime + "~" + scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        :formatter="formatterTableData"
        min-width="360"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="操作时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/rewardlist/sh')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="text"
            @click="openAddDialog(scope.row)"
            >审核
          </el-button>
          <span v-else>{{
            scope.row.status == 2
              ? "审核通过"
              : scope.row.status == 0
              ? "拒绝"
              : ""
          }}</span>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="审核"
      :dialogService="dialogService"
      :model="dialogModel"
      :submitData="dialogData"
      @close="dialogClose"
      @success="dialogSuccess"
      :rules="dialogRules"
      labelWidth="110px"
      class="note"
    >
      <el-form-item label="审核" prop="status">
        <el-radio-group v-model="dialogModel.status">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="0">拒绝</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="80"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import APPService from "service/APPService";
import Month from "service/constant/Month";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "rewardlist",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      time: "",
      itemId: "",
      status: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "已拒绝",
        },
        {
          code: "1",
          name: "待审核",
        },
        {
          code: "2",
          name: "已发放",
        },
      ],
      awardType: [
        //排行榜类型
        {
          code: "",
          name: "全部",
        },
      ],
      Week: [
        //周数
        {
          weekIndex: "",
          week: "全部",
          date: "",
        },
      ],
      formModel: {
        userId: "",
        cycle: "",
        status: "",
        awardType: "",
      },
      dialogModel: {
        status: "",
        remark: "",
      },
      dialogRules: {
        status: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      tableData: [],
      submitService: APPService.rewardlistList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        cycle: this.formModel.cycle,
        status: this.formModel.status,
        awardType: this.formModel.awardType,
        userId: this.formModel.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        params.startTime = this.time[0];
        params.endTime = this.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        status: this.dialogModel.status,
        remark: this.dialogModel.remark,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return APPService.rewardlistSH;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {
    "formModel.awardType"(val, oldVal) {
      this.formModel.cycle = "";
      this.setMonthWeek();
      if (val == 1) {
        this.Week = Month;
      } else if (val == 2) {
        this.getWeek();
      }
    },
  },
  methods: {
    setMonthWeek() {
      this.Week = [
        {
          weekIndex: "",
          week: "全部",
          date: "",
        },
      ];
    },
    load() {
      this.formModel = {
        cycle: "",
        awardType: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getintegralType();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      this.$refs.formDialog.open();
    },
    getintegralType() {
      this.doLoad(
        APPService.integralType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.awardType = [...this.awardType, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getWeek() {
      this.doLoad(
        APPService.weeklistNum,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.Week = [...this.Week, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        status: "",
        remark: "",
      };
      this.itemId = "";
    },
    formatterTableawardType(row, column, cellValue, index) {
      let value = "";
      this.awardType.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value ? value : "--";
    },
    formatterTablecycle(row, column, cellValue, index) {
      let value = "";
      this.awardType.forEach((item) => {
        if (item.code == row.awardType) {
          value = "第" + cellValue + item.name;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/RankIng/RewardList.vue